import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69e95b22"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user" }
const _hoisted_2 = { class: "user-wrapper" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("退出登录")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserFilled = _resolveComponent("UserFilled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_caretBottom = _resolveComponent("caretBottom")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dropdown, {
      class: "user-container",
      onCommand: _ctx.handleCommand
    }, {
      dropdown: _withCtx(() => [
        _createVNode(_component_el_dropdown_menu, { class: "user-dropdown" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_dropdown_item, { command: "logout" }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_2, [
          _createVNode(_component_el_avatar, {
            size: "medium",
            src: _ctx.$store.state.app.domainUrl + _ctx.info.avatar,
            onError: _ctx.errorHandler
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, { style: {"margin-top":"10px"} }, {
                default: _withCtx(() => [
                  _createVNode(_component_UserFilled)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["src", "onError"]),
          _createTextVNode(" " + _toDisplayString(_ctx.info.username) + " ", 1),
          _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [
              _createVNode(_component_caretBottom)
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }, 8, ["onCommand"])
  ]))
}